import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DoDeposit, GetDepositList, GetEventList, DeleteDeposit } from '../../common/actions/moreAction';
import { convertDepositString, convertStyle, dateFormation, isEmpty, isMobilePage, moneyValues, no_comma, toastr } from '../../common/cores';
import Pagenation from '../common/Pagenation';
import NavLink from 'react-router-dom/NavLink';
const WithDrawalContent = (props) => {

    const [money, setMoney] = useState(0);
    const [showHis, setShowHis] = useState(false);
    const [withdrawPassword, setWithdrawPassword] = useState("");
    const lists = props.deposit.data;
    const { page, user } = props;
    const [ids, setIds] = useState([]);

    const getLists = (page) => {
        props.GetDepositList("withdraw", page);
    }

    const password = (e) => {
        setWithdrawPassword(e.target.value);
    }

    const reset = () => {
        setMoney(0);
    }


    const onChange = (e) => {
        const { value, checked } = e.target; // 우선 e.target 에서 name 과 value 를 추출
        console.log(isNaN(Number(value)))
        if (checked) setIds([...ids, value]);
        else setIds(ids.filter(item => item !== value))
        console.log(ids);
        if (!isNaN(Number(no_comma(value))))
            setMoney(Number(no_comma(value)));
        else setMoney(0);
    };

    useEffect(() => {
        getLists(1);
    }, [props.page.perPage])

    const historyDelete = (value) => {
        props.DeleteDeposit({
            ids,
            all: value,
            typeStr: 'withdraw'
        })
    }

    const showHisotry = () => {
        setShowHis(!showHis);
    }

    const getMoneyFormat = (val) => {
        let res = "";
        if (val / 10000 > 0)
            res += (val / 10000) + "만원"
        val = val % 10000;
        if (val / 1000 > 0)
            res += (val / 1000) + "천원"
        val = val % 1000;
        if (val / 100 > 0)
            res += (val / 100) + "백원"
        val = val % 100;
        if (val / 10 > 0)
            res += (val / 10) + "십원"
        val = val % 10;
        if (val != 0)
            res += val
        return res
    }

    const onWithdraw = () => {
        if (money <= 0) {
          return toastr.warning("머니를 입력해주세요.")
        }
        if (isEmpty(withdrawPassword)) {
          return toastr.warning("환전비번을 입력해주세요.")
        }
        if (money < 10000) {
          return toastr.warning("환전최소금액 보다 작게 환전신청을 진행하실수 없습니다.")
        }
        let withdrawMoney = Math.floor(money / 10000) * 10000;
        props.DoDeposit(withdrawMoney, "withdraw", withdrawPassword)
      }
    return (
        <div className="contents_wrap">
            <div className="contents_box">
                <div className="con_box00">
                    <div className="tab_wrap">
                        <ul>
                            <li><NavLink to="/withdraw"><span className="tab">환전신청</span></NavLink></li>
                            <li><NavLink to="/withdraw/details"><span className="tab">환전내역</span></NavLink></li>

                        </ul>
                    </div>
                </div>
                <div className="con_box10">
                    <div className="info_wrap">
                        <div className="info1"><span className="info_title1">확인 / 주의사항</span></div>
                        <div className="info2">입금계좌를 통해 머니로 환전합니다.</div>
                        <div className="info3">

                            <img src="images/dot.jpg" className="dot" /> <span className="font05">입금하실 시, 예금주명은 회원님 성함으로 필히 입금바랍니다.</span><br />
                            <img src="images/dot.jpg" className="dot" /> 은행 점검시간을 확인하신 후 해당시간에는 <span className="font11">입금이 지연될 수 있으니 점검시간을 피해</span> 신청해 주시기 바랍니다.<br />
                            {/* <img src="images/dot.jpg" className="dot" /> 입금계좌는 수시로 변경되오니 반드시 <span className="font12">계좌번호문의 신청을 통해 계좌번호를 확인 후 입금</span>하여 주시기 바랍니다.<br /> */}
                            <img src="images/dot.jpg" className="dot" /> 자세한 문의사항은 고객센터(1:1문의)를 이용해 주시기 바랍니다.<br />
                        </div>
                    </div>
                </div>
                <div className="con_box10">
                    <div className="info_wrap">
                        <div className="info1"><span className="info_title1">입금 계좌 정보확인</span></div>
                        <div className="info3">
                            <img src="images/dot.jpg" className="dot" /> 입금 계좌번호는 쪽지로 발송되며, 계좌번호로 선 입금 바랍니다.
                    </div>
                    </div>
                </div>
                <div className="con_box10">
                    <div className="write_wrap">
                        <div className="write1"><span className="info_title2">환전금액 입력</span></div>
                        {!isMobilePage() &&
                            <div className="write3">
                                <table width="100%" border="0" cellSpacing="0" cellPadding="0" className="write_title_top">
                                    <tbody>
                                        <tr>
                                            <td className="write_title">현재 보유금액</td>
                                            <td className="write_basic"><span className="font14">{!isEmpty(user.data.balance) ? Number(user.data.balance.money).toLocaleString() : 0}</span>원</td>
                                        </tr>
                                        <tr>
                                            <td className="write_title">환전금액</td>
                                            <td className="write_basic">
                                                <input
                                                    type="text" placeholder="입금하실 금액을 입력해주세요"
                                                    inputMode="numeric" className="input1"
                                                    value={Number(money).toLocaleString()}
                                                    onChange={onChange}
                                                />
                                                <br /><br />
                                                {
                                                    moneyValues.map((item, index) => {
                                                        return (
                                                            <a key={index}><span className="btn1_2" key={index} style={{ marginRight: "4px" }} onClick={() => setMoney(money + item.value)}>{getMoneyFormat(item.value)}</span></a>
                                                        )
                                                    })
                                                }
                                                <a ><span className="btn1_1" onClick={() => setMoney(0)} style={{ marginRight: "4px" }}>정정</span></a></td>
                                        </tr>
                                        <tr>
                                            <td className="write_title">출금 비밀번호</td>
                                            <td className="write_basic">
                                                <input data-v-5b7f4dd8="" data-v-66023d98="" 
                                                    type="password" placeholder="출금 비밀번호를 입력해주세요"
                                                    inputMode="text" className="input1"
                                                    value={withdrawPassword}
                                                    onChange={password}/>
                                            </td>
                                        </tr>  
                                    </tbody>
                                </table>
                            </div>
                        }
                        {isMobilePage() &&
                            <div className="write3">
                                <table width="100%" border="0" cellSpacing="0" cellPadding="0" className="write_title_top">
                                    <tbody>
                                        <tr>
                                            <td className="write_title" style={{ width: "30%" }}>현재 보유금액</td>
                                            <td className="write_basic"><span className="font14">{!isEmpty(user.data.balance) ? Number(user.data.balance.money).toLocaleString() : 0}</span>원</td>
                                        </tr>
                                        <tr>
                                            <td className="write_title" style={{ width: "30%" }}>환전금액</td>
                                            <td className="write_basic">
                                                <input
                                                    type="text" placeholder="환전하실 금액을 입력해주세요"
                                                    inputMode="numeric" className="input1"
                                                    value={Number(money).toLocaleString()}
                                                    onChange={onChange}
                                                />
                                                <table width="100%" border="0" align="center" cellSpacing="2" cellPadding="0">
                                                    <tbody>
                                                        <tr>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 10000)}>1만원</span></a></td>
                                                            <td width="10%" align="center"><a ><span className="m_btn1_2" onClick={() => setMoney(money + 30000)}>3만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 50000)}>5만원</span></a></td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 100000)}>10만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 500000)}>50만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 1000000)}>100만원</span></a></td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 5000000)}>500만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 10000000)}>1000만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_1" onClick={() => setMoney(0)}>정정</span></a></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="write_title">출금 비밀번호</td>
                                            <td className="write_basic">
                                                <input data-v-5b7f4dd8="" data-v-66023d98="" 
                                                    type="password" placeholder="출금 비밀번호를 입력해주세요"
                                                    inputMode="text" className="input1"
                                                    value={withdrawPassword}
                                                    onChange={password}/>
                                            </td>
                                        </tr>  
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                </div>
                <div className="con_box30">
                    <div className="btn_wrap_center">
                        <ul>
                            <li><a onClick={onWithdraw}><span className="btn3_1" >환전신청하기</span></a></li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>

    );
};

const mapStateToProps = state => ({
    user: state.user,
    deposit: state.more.deposit,
    page: state.page
})

export default connect(mapStateToProps, { GetDepositList, DoDeposit, DeleteDeposit })(WithDrawalContent);


// WEBPACK FOOTER //
// ./src/components/account/WithDrawalContent.js